import PropTypes from 'prop-types';
import Head from 'next/head';
import Layout from '../layout';
import { Page, Wrap } from '../../styled';

const getWPPage = (fetchData) => {
  const WPPage = (props) => {
    const { title, content, meta } = props;

    return (
      <Layout>
        <Page>
          <Head>
            <title>{meta.title}</title>
            <meta name="description" content={meta.description} />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1"
            />
          </Head>
          <Wrap>
            <h1>{title}</h1>
            <div dangerouslySetInnerHTML={{ __html: content }} />
          </Wrap>
        </Page>
      </Layout>
    );
  };

  WPPage.getInitialProps = async ({ query }) => {
    const { lang } = query;
    const { title, content, meta } = await fetchData({ lang });

    return { title, content, meta };
  };

  WPPage.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    meta: PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }).isRequired,
  };

  return WPPage;
};

export default getWPPage;
